<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Teslimat Şehirleri</v-toolbar-title>
      <v-divider class="mx-3" inset vertical></v-divider>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Ara"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="showAddDialog" class="mb-2">
        <v-icon left>add</v-icon>
        Yeni Şehir Ekle
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="cities"
      :search="search"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-left"><strong>{{ props.item.name }}</strong></td>
        <td class="text-xs-left">{{ props.item.duration }} gün</td>
        <td class="text-xs-center">
          <v-icon small class="mr-2" @click="editCity(props.item)" color="blue">edit</v-icon>
          <v-icon small @click="deleteCity(props.item)" color="red">delete</v-icon>
        </td>
      </template>

      <template v-slot:no-data>
        <div class="text-xs-center pa-4">
          <p>{{ loading ? 'Yükleniyor...' : 'Şehir bulunamadı.' }}</p>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedIndex === -1 ? 'Yeni Şehir' : 'Şehir Düzenle' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  label="Şehir Adı"
                  required
                  maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="editedItem.duration"
                  label="Kargo Süresi (gün)"
                  type="number"
                  min="1"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">İptal</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click="save"
            :loading="saving"
            :disabled="!isFormValid"
          >
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Şehir Sil</v-card-title>
        <v-card-text>
          <strong>{{ cityToDelete && cityToDelete.name }}</strong> şehrini silmek istediğinizden emin misiniz?
          <br><br>
          <v-alert type="warning" value="true">Bu işlem geri alınamaz!</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="deleteDialog = false">İptal</v-btn>
          <v-btn color="red darken-1" flat @click="confirmDelete" :loading="deleting">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
      <v-btn dark flat @click="snackbar = false">Kapat</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      loading: false,
      saving: false,
      deleting: false,
      dialog: false,
      deleteDialog: false,
      editedIndex: -1,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      cityToDelete: null,
      headers: [
        { text: 'ID', value: 'id', align: 'center', sortable: true },
        { text: 'Şehir Adı', value: 'name', align: 'left', sortable: true },
        { text: 'Kargo Süresi', value: 'duration', align: 'left', sortable: true },
        { text: 'İşlemler', value: 'actions', align: 'center', sortable: false },
      ],
      editedItem: { name: '', duration: 1 },
      defaultItem: { name: '', duration: 1 },
    };
  },

  computed: {
    cities() {
      return this.$store.state.deliveryCities.all || [];
    },
    isFormValid() {
      return (
        this.editedItem.name &&
        this.editedItem.name.trim().length > 0 &&
        Number(this.editedItem.duration) > 0
      );
    },
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;
      try {
        await this.$store.dispatch('deliveryCities/getCities');
      } catch (error) {
        this.showError('Şehirler yüklenirken hata oluştu');
      } finally {
        this.loading = false;
      }
    },

    showAddDialog() {
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem };
      this.dialog = true;
    },

    editCity(item) {
      this.editedIndex = this.cities.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteCity(item) {
      this.cityToDelete = item;
      this.deleteDialog = true;
    },

    async confirmDelete() {
      this.deleting = true;
      try {
        await this.$store.dispatch('deliveryCities/deleteCity', this.cityToDelete.id);
        this.showSuccess('Şehir başarıyla silindi');
        this.deleteDialog = false;
        this.cityToDelete = null;
      } catch (error) {
        const errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          'Şehir silinirken hata oluştu';
        this.showError(errorMessage);
      } finally {
        this.deleting = false;
      }
    },

    async save() {
      if (!this.isFormValid) return;

      this.saving = true;
      try {
        const payload = {
          ...this.editedItem,
          name: this.editedItem.name.trim(),
          duration: Number(this.editedItem.duration),
        };

        if (this.editedIndex === -1) {
          await this.$store.dispatch('deliveryCities/createCity', payload);
          this.showSuccess('Şehir başarıyla oluşturuldu');
        } else {
          await this.$store.dispatch('deliveryCities/updateCity', payload);
          this.showSuccess('Şehir başarıyla güncellendi');
        }
        this.close();
      } catch (error) {
        const errorMessage =
          (error.response && error.response.data && error.response.data.message) ||
          'Şehir kaydedilirken hata oluştu';
        this.showError(errorMessage);
      } finally {
        this.saving = false;
      }
    },

    close() {
      this.dialog = false;
      this.editedItem = { ...this.defaultItem };
      this.editedIndex = -1;
    },

    showSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = 'success';
      this.snackbar = true;
    },

    showError(message) {
      this.snackbarText = message;
      this.snackbarColor = 'error';
      this.snackbar = true;
    },
  },
};
</script>
